export default "__VITE_ASSET__DHD2MEB7__"